// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Katr1","icon":"styles_icon__3r6DZ"};